module.exports = __webpack_public_path__ + "static/img/bg_consult_anonymous@2x.55a04df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_consult_anonymous@2x.png
// module id = UUL4
// module chunks = 1